import React from 'react';
import {UserAvatarProps} from '../../@types/components/UserAvatar';

export default class UserAvatar<P extends UserAvatarProps = UserAvatarProps> extends React.Component<P> {
    render() {
        const {user, ...props} = this.props;

        return <img
                {...props}
                src={user.avatar}
                title={user.name}
                alt={user.name}
        />;
    }
}
